import parseDialogue from "../../util/parseDialogue";

export const TsumaraRevisit = parseDialogue(`
tsumara:revisit:100-200

#100 Welcome back, consumer, to Network City, retailer for the new future net technologies, software for the here and beyond. Can I be of assistance?
>200 I'd like to purchase some software.
>0 No thanks.
`);
